import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-slider-panel',
  templateUrl: './slider-panel.component.html',
  styleUrls: ['./slider-panel.component.scss']
})
export class SliderPanelComponent implements OnInit, OnDestroy {

  private static openPanelCount = 0;

  @Input() public data?: any;
  @Input() public layer?: number;
  @Input() public pageWidth?: number;
  @Input() onClose: () => void;

  darkMode$: Observable<boolean>;
  backgroundWidth: number;

  constructor(
    private store: Store<{ darkMode: boolean }>,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) { 
    this.darkMode$ = store.select('darkMode')
  }

  ngOnInit(): void {
    SliderPanelComponent.openPanelCount += 1;
    this.renderer.addClass(this.document.body, 'slider-panel-open');

    if(this.pageWidth){
      this.backgroundWidth = (100 - this.pageWidth)
    }
  }

  ngOnDestroy(): void {
    SliderPanelComponent.openPanelCount = Math.max(0, SliderPanelComponent.openPanelCount - 1);

    if (SliderPanelComponent.openPanelCount === 0) {
      this.renderer.removeClass(this.document.body, 'slider-panel-open');
    }
  }

}
